import React from "react";
import ToggleButton from "./formComponents/ToggleButton";

const MyToggle = ({ checked = false, value, onChange, label = "Favorite" }) => {
  const isChecked = Boolean(value !== undefined ? value : checked);

  const handleChange = (e) => {
    if (typeof onChange === "function") {
      onChange(e.target.checked);
    }
  };

  return (
    <ToggleButton value={isChecked} onChange={handleChange} label={label} />
  );
};

export default MyToggle;
